const useFormatBreadcrumb = (url) => {
  let splitUrl = url.split('/')
  let res = ''
  for (let sp in splitUrl) {
    res = res.concat(splitUrl[sp])
    if (sp < splitUrl.length - 1) {
      res = res.concat('/')
    }
  }
  return [res]
}

export default useFormatBreadcrumb
